/**
 * Strips protocol, www, trailing paths/query-strings, and lowercases.
 * Returns null if the result isn't a valid domain.
 */
export function normalizeDomain(input: string): string | null {
  if (!input.trim()) return null
  let clean: string
  try {
    clean = new URL(input).hostname
  } catch {
    clean = input.replace(/^(https?:\/\/)?(www\.)?/i, '').split('/')[0].split('?')[0]
  }
  clean = clean.replace(/^www\./i, '').toLowerCase().trim()
  const regex = /^(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,})$/
  return regex.test(clean) ? clean : null
}
